import api from './client';

async function fetchNotifications(page = 0, perPage = 15) {
    const url = `/notifications?currentPage=${page}&perPage=${perPage}`;
    const { data } = await api.get(url);
    return data;
}

async function fetchNotification(id, page = 0, perPage = 15) {
    const url = `/notifications/${id}?currentPage=${page}&perPage=${perPage}`;
    const { data } = await api.get(url);
    return data;
}

async function fetchActiveNotification() {
    const url = '/notifications/active';
    const { data } = await api.get(url);
    return data;
}

async function createNotification(title, message, group, file) {
    const url = '/notifications';

    const body = new FormData();
    body.append('title', title);
    body.append('message', message);
    body.append('group', group);

    if (file) {
        body.append('file', file);
    }

    const { data } = await api.post(url, body);
    return data;
}

export {
    fetchNotifications,
    fetchNotification,
    createNotification,
    fetchActiveNotification,
};
